var _g, _g2, _g3, _g4, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 13.229 13.229",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.020969 0 0 .020969 6.6609 6.6609)",
    fill: "none",
    strokeWidth: 3.04
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 288c126.2 0 196.36 0 242.18-45.822 45.822-45.822 45.822-115.98 45.822-242.18s0-196.36-45.822-242.18c-45.822-45.822-115.98-45.822-242.18-45.822s-196.36 0-242.18 45.822c-45.822 45.822-45.822 115.98-45.822 242.18s0 196.36 45.822 242.18c45.822 45.822 115.98 45.822 242.18 45.822z",
    fill: "#fefefe",
    stroke: "#00f",
    strokeOpacity: 0.75
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.229,
    height: 13.229,
    display: "none",
    fill: "#fefefe",
    strokeWidth: 0.026458
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m7.4441 2.2306v6.3083l0.79802 1.1132v-3.3397h2.7931v2.2265l0.79802 1.1132v-6.3083l-0.79802-1.1132v3.3397h-2.7931v-2.2265z",
    fill: "#4f469e"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m3.1348 3.1298h6.6501l-0.66502 0.78863h-2.2167l1e-7 6.1119-0.88669 0.59147v-6.7033h-2.2167z",
    fill: "#668ad3"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m1.2385 3.4396 2.8539 5.0275v2.6335h0.87813v-2.6335l1.7666-3.1123h-0.86398l-1.3416 2.3941-2.4149-4.3093z",
    fill: "#46abf6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.7a0150b003eb8fa9d25a4580e316470f.svg";
export { ForwardRef as ReactComponent };